import ATextField from "../ATextField";
import { getIn } from 'formik';

const FormikATextField = ({ field, form, ...props }) => {
  
  const onChange = (event) => {
    form.setFieldValue(field.name, event.target.value);
  };

  const errorMessage = getIn(props.allErrors, field.name);
  
  return (
    <ATextField
      parentClassName={
        props.parentClassName
      }
      name={field.name}
      value={field.value}
      placeholder={props.placeholder}
      label={props.label}
      onChange={onChange}
      autoFocus={props.autoFocus}
      onBlur={() => form.setFieldTouched(field.name, true)}
      errorMessage={errorMessage}
      required={props.required}
    />
  );
};

export default FormikATextField;
